<!-- Spinner Container -->
<div
  class="spinner-container"
  [class.spinner-compact]="size === 'compact'"
  [class.spinner-medium]="size === 'medium'"
  [class.spinner-full]="size === 'full'"
  [class.spinner-overlay]="overlay"
>
  <!-- Background Effects (nur für medium/full mit overlay oder showBackground) -->
  <ng-container *ngIf="showBackground && (size === 'medium' || size === 'full')">
    <div class="gradient-bg"></div>
  </ng-container>

  <!-- Floating Particles (nur für full oder medium mit overlay) -->
  <ng-container *ngIf="showParticles && overlay && (size === 'medium' || size === 'full')">
    <div class="particle particle-1"></div>
    <div class="particle particle-2"></div>
    <div class="particle particle-3"></div>
    <div class="particle particle-4"></div>
  </ng-container>

  <div class="spinner-content">
    <!-- Logo Container mit Orbital Rings (nur für medium/full) -->
    <div class="logo-container" *ngIf="size !== 'compact'">
      <!-- Orbital Rings System -->
      <div class="orbit-ring-1"></div>
      <div class="orbit-ring-2"></div>
      <div class="orbit-ring-3"></div>

      <!-- Logo (nur für full) -->
      <img
        *ngIf="size === 'full' && showLogo"
        src="assets/img/logo-no-name.svg"
        alt="FixPlaner"
        class="logo-icon"
      />
    </div>

    <!-- App Name Logo (nur für full mit showAppName) -->
    <div class="app-name-logo" *ngIf="size === 'full' && showAppName">
      <img
        src="assets/img/logo-text.svg"
        alt="FixPlaner"
        class="logo-text logo-text-light"
      />
      <img
        src="assets/img/logo-text-dark.svg"
        alt="FixPlaner"
        class="logo-text logo-text-dark"
      />
    </div>

    <!-- Loading Dots (immer anzeigen) -->
    <div class="loading-dots">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</div>
